import { useMutation, useQuery, useQueryClient } from "react-query";
import axiosInstance from "../config/Axios";
import { useCustomToast } from "../pages/Contexts/ToastContext";
import { handleResErrors } from "./utils";

export const useGetSmartAdSchedules = (params = {}) => {
    const { showToast } = useCustomToast();
    return useQuery(
        ["smartAdSchedules", params],
        () => axiosInstance.get("/smart-ad-scheduler", { params }).then((r) => r.data),
        {
            keepPreviousData: true,
            refetchInterval: params.refetchInterval ?? false,
            onError: (err) => handleResErrors(err, showToast),
        }
    );
};

export const useGetSmartAdSchedule = (id) => {
    const { showToast } = useCustomToast();
    return useQuery(
        ["smartAdSchedule", id],
        () => axiosInstance.get(`/smart-ad-scheduler/${id}`).then((r) => r.data),
        { enabled: !!id, onError: (err) => handleResErrors(err, showToast) }
    );
};

export const useCreateSmartAdSchedule = () => {
    const qc = useQueryClient();
    const { showToast } = useCustomToast();
    return useMutation(
        (payload) => axiosInstance.post("/smart-ad-scheduler/create", payload).then((r) => r.data),
        {
            onSuccess: () => {
                qc.invalidateQueries("smartAdSchedules");
                showToast("success", "Smart Ad Scheduler", "Smart schedule created successfully!");
            },
            onError: (err) => handleResErrors(err, showToast),
        }
    );
};

export const useDeleteSmartAdSchedule = () => {
    const qc = useQueryClient();
    const { showToast } = useCustomToast();
    return useMutation(
        (id) => axiosInstance.delete(`/smart-ad-scheduler/${id}/delete`).then((r) => r.data),
        {
            onSuccess: () => {
                qc.invalidateQueries("smartAdSchedules");
                showToast("success", "Smart Ad Scheduler", "Schedule removed.");
            },
            onError: (err) => handleResErrors(err, showToast),
        }
    );
};

export const useGetSmartAdLogs = (id, page = 1) => {
    const { showToast } = useCustomToast();
    return useQuery(
        ["smartAdLogs", id, page],
        () => axiosInstance.get(`/smart-ad-scheduler/${id}/logs`, {
            params: { page, per_page: 20 },
        }).then((r) => r.data),
        {
            enabled: !!id,
            keepPreviousData: true,
            onError: (err) => handleResErrors(err, showToast),
        }
    );
};
